import cn from 'classnames';
import { FC } from 'react';

import styles from './HeaderDivider.module.scss';

type HeaderDividerProps = {
  className?: string;
  testID?: string;
};

/** @deprecated
 * The new header divider is inside widgets/Header both for desktop and mobile.
 */
export const HeaderDivider: FC<HeaderDividerProps> = (props) => {
  const { className, testID } = props;

  // TODO: mb need to refactoring with hook useHeaderDivider
  return (
    <div className={cn(styles.container, className)} data-testid={testID} />
  );
};
